import { KeyMapKeys } from '@locales/lokalise/keyMap';
import i18next, { i18n } from 'i18next';

export interface NameValuePair {
  name: string;
  value: string;
}

class ValueFromEnumService {
  /**
   * @deprecated
   * Please use getValueFromEnumsWithI18n instead
   */
  getValueFromEnums = (value: string, enumConstant: NameValuePair[]): string => {
    const idx = enumConstant.findIndex((item) => value === item.value);

    return idx !== -1 ? i18next.t(enumConstant[idx].name as KeyMapKeys) : value;
  };

  getValueFromEnumsWithI18n = <T extends NameValuePair[]>(value: T[0]['value'] | null, enumConstant: T, i18n: i18n) => {
    if (value === null) {
      return '';
    }

    const idx = enumConstant.findIndex((item) => value === item.value);

    return idx !== -1 ? i18n.t(enumConstant[idx].name as KeyMapKeys) : value;
  };

  getValueFromEnumsOrText = (value: string, enumConstant: NameValuePair[], text = ''): string => {
    const idx = enumConstant.findIndex((item) => value === item.value);

    return idx !== -1 ? i18next.t(enumConstant[idx].name as KeyMapKeys) : text;
  };

  getMultiValueFromEnum = (valueArray: Array<string>, enumConstant: NameValuePair[]): string => {
    return valueArray.map((c) => this.getValueFromEnums(c, enumConstant)).join(', ');
  };

  getObjectFromEnums = (value: string, enumConstant: NameValuePair[]): NameValuePair | null => {
    const idx = enumConstant.findIndex((item) => value === item.value);

    return idx !== -1 ? enumConstant[idx] : null;
  };
}

export const valueFromEnumService = new ValueFromEnumService();
